import React from 'react'
import PropTypes from 'prop-types'
import {
  AutocompleteStyle,
  FormError,
  InputBaseStyle,
  TextFieldModalStyle,
  TextFieldStyle
} from '../../Deal.style'
import PaperAutoComplete from '../../../../components/PaperAutoComplete/PaperAutoComplete'
import NumericFormatModal from '../../../../components/ModalApp/components/NumericFormatModal/NumericFormatModal'
import { Label } from '../../../../components/styled/global.style'
import { Box, Typography } from '@mui/material'
import { ButtonGroupStyle, OptionContainer, OptionCounterparty, SideButton } from '../../Deal.style'

const SwapDealClientSide = ({
  form,
  sides,
  handelFormChange,
  handelFocusCurrencyPair,
  handelBlurCurrencyPair,
  errors,
  clients,
  handelDateChange,
  swapOption,
  fixingSource
}) => {
  return (
    <>
      <Box width={'100%'}>
        <Label>Trade Type *</Label>
        <InputBaseStyle value={`Client ${form.deal_type.name}`} disabled />
      </Box>
      <Box width={'100%'}>
        <Label>Counterparty *</Label>
        {Array.isArray(clients.data) && (
          <AutocompleteStyle
            onChange={(event, element) => {
              event.target.name = 'client'
              element = element ?? ''
              handelFormChange(event, element)
            }}
            size={'small'}
            value={form.client}
            onBlur={handelBlurCurrencyPair}
            options={clients.data.map(({ name }) => name)}
            renderOption={(props, option) => {
              return (
                <OptionContainer {...props} key={option}>
                  <Typography>{option.split(' ').slice(0, -1).join(' ')} </Typography>
                  <OptionCounterparty>{option.split(' ').at(-1)} </OptionCounterparty>
                </OptionContainer>
              )
            }}
            renderInput={params => (
              <TextFieldModalStyle fullWidth {...params} placeholder={'Select CP'} />
            )}
            ListboxComponent={PaperAutoComplete}
          />
        )}
      </Box>
      <Box width={'100%'}>
        <Label>Trade Date *</Label>
        <TextFieldStyle type="datetime-local" value={form.trade_date} disabled />
      </Box>
      <Box width={'100%'}>
        <Label>Currency Pair *</Label>
        <InputBaseStyle
          value={form.currency_pair}
          name="currency_pair"
          onChange={handelFormChange}
          onFocus={handelFocusCurrencyPair}
          onBlur={handelBlurCurrencyPair}
          error={errors.currency_pair}
        />
        {errors.currency_pair !== '' && <FormError>{errors.currency_pair}</FormError>}
      </Box>
      <Box width={'100%'}>
        <Label>Client Side *</Label>
        {Array.isArray(sides.data) && (
          <ButtonGroupStyle variant="outlined">
            {sides.data.map(({ name }, id) => (
              <SideButton
                name="client_side"
                key={id}
                value={name}
                select={String(form.client_side === name)}
                onClick={handelFormChange}
              >
                {name}
              </SideButton>
            ))}
          </ButtonGroupStyle>
        )}
      </Box>
      <Box width={'100%'}>
        <Label>Quantity *</Label>
        <NumericFormatModal
          value={form.quantity}
          name="quantity"
          handelFormChange={handelFormChange}
          placeholder="0.00"
        />
      </Box>
      <Box width={'100%'}>
        <Label>Far Leg Quantity *</Label>
        <NumericFormatModal
          value={form.far_leg_quantity}
          name="far_leg_quantity"
          handelFormChange={handelFormChange}
          placeholder="0.00"
        />
      </Box>
      <Box width={'100%'}>
        <Label>Price *</Label>
        <InputBaseStyle
          value={form.client_price}
          name="client_price"
          onChange={handelFormChange}
          placeholder="0.0000"
        />
      </Box>
      <Box width={'100%'}>
        <Label>Far Price *</Label>
        <InputBaseStyle
          value={form.client_far_price}
          name="client_far_price"
          onChange={handelFormChange}
          placeholder="0.0000"
        />
      </Box>
      <Box width={'100%'}>
        <Label>Client Value Date *</Label>
        <TextFieldStyle
          type="date"
          name="client_value_date"
          value={form.client_value_date}
          placeholder="dd-mm-yyyy"
          onChange={event => handelDateChange('client_value_date', event.target.value)}
        />
      </Box>
      <Box width={'100%'}>
        <Label>Far Value Date *</Label>
        <TextFieldStyle
          type="date"
          name="client_far_value_date"
          value={form.client_far_value_date}
          placeholder="dd-mm-yyyy"
          onChange={event => handelDateChange('client_far_value_date', event.target.value)}
        />
      </Box>
      {swapOption && (
        <>
          <Box width={'100%'}>
            <Label>Fixing Date *</Label>
            <TextFieldStyle
              type="date"
              variant="outlined"
              value={form.fixing_date}
              onChange={event => handelDateChange('fixing_date', event.target.value)}
            />
          </Box>
          <Box width={'100%'}>
            <Label>Far Fixing Date *</Label>
            <TextFieldStyle
              type="date"
              name="far_fixing_date"
              value={form.far_fixing_date}
              placeholder="dd-mm-yyyy"
              onChange={event => handelDateChange('far_fixing_date', event.target.value)}
            />
          </Box>

          <Box width={'100%'}>
            <Label>Fixing Source *</Label>
            {Array.isArray(fixingSource.data) && (
              <AutocompleteStyle
                onChange={(event, element) => {
                  event.target.name = 'fixing_source'
                  element = element ?? ''
                  handelFormChange(event, element)
                }}
                size={'small'}
                value={form.fixing_source}
                options={fixingSource.data.map(({ name }) => name)}
                renderInput={params => (
                  <TextFieldModalStyle fullWidth {...params} placeholder="Select Fix Source" />
                )}
                ListboxComponent={PaperAutoComplete}
              />
            )}
          </Box>
        </>
      )}

      <Box width={'100%'}>
        <Label>Client Note</Label>
        <InputBaseStyle value={form.client_note} name="client_note" onChange={handelFormChange} />
      </Box>
    </>
  )
}

export default SwapDealClientSide

SwapDealClientSide.propTypes = {
  form: PropTypes.object,
  sides: PropTypes.object,
  handelFormChange: PropTypes.func,
  handelFocusCurrencyPair: PropTypes.func,
  handelBlurCurrencyPair: PropTypes.func,
  handelDateChange: PropTypes.func,
  errors: PropTypes.object,
  swapOption: PropTypes.bool,
  clients: PropTypes.object,
  fixingSource: PropTypes.object
}
